// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Heading__Jsx3 = require("../../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");

function PropertyAddressValidationCallout(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              props.icon === "Error" ? JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Cancel",
                                      size: 16,
                                      color: Theme__Color__Vars.crimson
                                    }) : JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "AttentionAlt",
                                      size: 30,
                                      color: Theme__Color__Vars.black
                                    }),
                              JsxRuntime.jsx(Heading__Jsx3.make, {
                                    as_: "h5",
                                    children: props.heading
                                  })
                            ],
                            className: "flex flex-row items-center gap-2"
                          }),
                      props.children
                    ],
                    className: "flex flex-col items-stretch gap-2 p-1"
                  }),
              className: "border border-tan-error-500 p-2"
            });
}

var make = PropertyAddressValidationCallout;

exports.make = make;
/* Icon__Jsx3 Not a pure module */
